{
  "id": "campaign-025",
  "name": "Misty Park",
  "seed": "campaign:25",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..._........",
    "..._.~~.....",
    "..._.~......",
    "..._b..b....",
    "..._........",
    ".h._h...x...",
    "..._........",
    "____________",
    "..._......x.",
    "..._........",
    ".,._........",
    ",,,_l.......",
    ",.._........",
    ",.._....sss.",
    "........sss.",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 0,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "repair",
      "x": 5,
      "y": 15
    }
  ],
  "generatorVersion": 3,
  "level": 25,
  "biome": "park",
  "par": {
    "reel": 6066,
    "push": 4930,
    "selfPropelled": 4548,
    "tractor": 4410,
    "zeroTurn": 3177,
    "fairway": 2004
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 22,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
